module.exports = __webpack_public_path__ + "static/media/right-bracket-key.938f550a.svg";